import logoImage from '../assets/logo.png';

export default function LoadingScreen() {
  return (
    <div className="animate-fade-in fixed inset-0 bg-white flex items-center justify-center">
      {/* Logo with bounce animation */}
      <img
        src={logoImage}
        alt="Logo"
        className="w-24 h-24 object-contain animate-logo-bounce"
      />
    </div>
  );
}
